import React, { useState, useEffect, memo } from 'react';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../images/icons/upload_new.svg';
import { Formik, Form } from 'formik';
import {
  financialInstituteDocUpload,
  financialInstituteDocUploaded,
  UploadFileToS3,
  financialInstituteGetAPI
} from '../../../common/constants/api';
import ShowGetImage from '../../../common/components/ShowGetImage/ShowGetImage';

import PopUp from '../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

const UploadDocFi = ({ fiId }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const [dontClose, setDontClose] = useState(true);

  return (
    <Formik
      initialValues={{
        isEditMode: false,
        file: [],
        imgUrl: []
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        setValues
      }) => {
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);
          await financialInstituteDocUpload(fiId)
            .then(res => {
              UploadFileToS3(res?.url, values?.file[0][0]).then(() => {
                financialInstituteDocUploaded(fiId, res?.requestId).then(
                  res => {
                    setType('success');
                    setText('Uploaded the File successfully.');
                    setShow(true);
                    setDontClose(false);
                  }
                );
              });
            })
            .catch(err => {
              setShow(false);
            });
        }

        function getfun() {
          setType('loading');
          setText('Please wait while retrieving data...');
          setShow(true);
          setDontClose(true);

          financialInstituteGetAPI(fiId)
            .then(res => {
              setImgLinkData(res?.url);
              setValues({
                ...values,
                isEditMode: res?.url ? true : false
              });

              setShow(false);
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
            });
        }

        useEffect(() => {
          getfun();
        }, []);

        return (
          <React.Fragment>
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 px-7 sm:px-5 bg-white mt-5 ml-4 mr-7 pb-12 rounded md:w-7/12"
              style={{
                border: '1px solid #e0dada'
              }}
            >
              <>
                <div className="mt-10 flex items-center flex-col">
                  <p className="font-medium mb-3 items-baseline text-base">
                    Upload Document
                  </p>
                  <div
                    className="bg-white  flex justify-center rounded-lg border border-navy-200 md:border-none
                        py-9  pr-5 pl-8  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
                  >
                    {imgLinkData && !Edit1 ? (
                      <div className="">
                        <ShowGetImage
                          img={imgLinkData}
                          setEdit={setEdit1}
                          showInPopUP={true}
                        />
                      </div>
                    ) : (
                      <GlobalUploadComp
                        data={values}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        initialImg={initialImg}
                        subInst="Click here to upload"
                        subtext="Upload File"
                      />
                    )}
                  </div>
                </div>
                {values?.file.length == 1 && values?.file[0] && (
                  <button
                    type="submit"
                    onClick={() => {
                      if (values?.file[0] && values?.file[0][0]) {
                        fileUpload();
                      }
                    }}
                    className={
                      'submitButton text-14 w-56 h-12 font-medium  font-roboto'
                    }
                  >
                    Upload Document
                  </button>
                )}
              </>
            </Form>

            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={dontClose}
              autoClose={type === 'success'}
            />
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default memo(withErrorHandler(UploadDocFi));
